import * as React from 'react';
import { BrandColorsType } from 'toca-themes';
var PageErrorMessage = function (props) {
    return (React.createElement("div", { style: {
            fontWeight: 'bold',
            color: props.color || BrandColorsType.redDefault,
        } }, props.message || (React.createElement(React.Fragment, null,
        React.createElement("p", null, "Oops. Something went wrong."),
        React.createElement("p", null, "This issue may be temporary. Please try again and if the problem persists, contact our support team.")))));
};
export default PageErrorMessage;
//# sourceMappingURL=PageErrorMessage.js.map